(function ($) {
  /**Menu**/
  function customSubMenu(){
    $( ".nav-dropdown.nav-dropdown--first" ).each(function( index ) {
      if(!$(this).find(".nav-dropdown--second").length){
          $(this).parent().addClass("not-dropdown-second");
      }
    });
  }

  customSubMenu();

  /**Search page**/
  $('.search__form .input-group__submit').on('click', function(){
    var input_search = $(".search__form .form__input").val().replace("/", " ");
    $(".search__form .form__input").val(input_search);
  });

  /**FOOTER**/
  $('.menu_links > h2').on('click', function(){
    var parent = $(this).parent(),
        windowWidth = window.innerWidth;

    if(windowWidth <= 800){
      parent.toggleClass("open");
    }
  });

  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
          return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
      }
    }
    return 1;
  };

    $(document).ready(function() {
      //remove provine
      if($(".address_form").length){
        $(".address_form").find('option[value="Putrajaya"]').remove();
      }

      if($(".review-tab-title").length){
        $(".review-tab-title").hide();
        $(".review-tab-m").parents(".tabs__nav-item-m").hide();
      }

      if($("body").hasClass("template-product")){
        moveReviewToTabs();
      }

    });

  /**Disable Scroll on mobile**/
  function disableScroll(){
    $('.header__nav-toggle').on('touchmove', function (evt) {
      evt.preventDefault();
    });
  }

  function enableScroll(){
    $('.header__nav-toggle').off('touchmove', function (evt) {
        evt.preventDefault();
    });
  }

  $('.header__nav-toggle').on('click', function (evt) {
    checkDevice();
  });

  function checkDevice(){
    var windowWidth = window.innerWidth;

    if(windowWidth <= 1024 && $('.sidebar-nav').hasClass('sidebar-nav--open')){
      disableScroll();
    }
    else {
      enableScroll();
    }
  }

  function closeMinicart() {
    if(headerSearch.hasClass('header-search--open')) {
      headerSearch.removeClass('header-search--open');
    }

    if(miniCart.hasClass('mini-cart--open')) {
      miniCart.removeClass('mini-cart--open');
    }

    if(userLink.hasClass('open')) {
      userLink.removeClass('open');
      navUser.hide();
    }

    $('.page__overlay').removeClass('page__overlay--open');

    $("body").removeClass('no-scroll');
  }

  $('.page__overlay').bind('touchstart', function(e){
    closeMinicart();
  });

  // AA tracking button for mini cart
  $(document).on("click", '.close-minicart', function (event) {
    const detail = {
      type: 'continueShopping',
      label: 'continueShopping'
    }
    dispatchEvent(detail);
    closeMinicart();
  });  

  $(document).on("click", '.mini-cart__buttons .button--checkout', function (event) {
    const detail = {
      type: 'proceedCheckout',
      label: 'proceedCheckout'
    }
    dispatchEvent(detail);
  });

  $(window).resize(function() {
    checkDevice();
    showCodeContent(true);
    moveReviewToTabs();
  });
   
  /**Nav User Drop Down in Header**/
  var userLink = $('.user__link');
  var navUser = userLink.find('.nav-dropdown');
  var miniCart = $(".mini-cart");
  var headerSearch = $(".header-search");

  $(document).click(function (e) {
    if (!e) e = window.event;

    if($(e.target).hasClass("nav-dropdown__link")){
      //sub menu
      window.location.href = $(e.target).attr("href");
    }
    else if( $(e.target).hasClass("user__link") ||  $(e.target).parents(".user__link").length
        || $(e.srcElement).parents(".user__link").length
        || $(e.srcElement).hasClass("user__link")  ){

      if(headerSearch.hasClass('header-search--open')) {
        headerSearch.removeClass('header-search--open');
      }

      if(miniCart.hasClass('mini-cart--open')) {
        miniCart.removeClass('mini-cart--open');
      }

      if(userLink.hasClass('open')) {
        userLink.removeClass('open');
        $("body").removeClass('no-scroll');
        navUser.hide();
        $('.page__overlay').removeClass('page__overlay--open');
      }
      else {
        userLink.addClass('open');
        $("body").addClass('no-scroll');
        navUser.show();
        $('.page__overlay').addClass('page__overlay--open');
      }
    }
    else if( $(e.target).hasClass("search-form") ||  $(e.target).parents(".search-form").length  ){
      if(miniCart.hasClass('mini-cart--open')) {
        miniCart.removeClass('mini-cart--open');
      }

      if(userLink.hasClass('open')) {
        userLink.removeClass('open');
        navUser.hide();
      }
    }
    else {
      if( $(e.target).hasClass("page__overlay")){
        if(headerSearch.hasClass('header-search--open')) {
          headerSearch.removeClass('header-search--open');
        }

        if(miniCart.hasClass('mini-cart--open')) {
          miniCart.removeClass('mini-cart--open');
        }

        if(userLink.hasClass('open')) {
          userLink.removeClass('open');
          navUser.hide();
        }

        $('.page__overlay').removeClass('page__overlay--open');
        $("body").removeClass('no-scroll');
      }
      else if( $(e.target).hasClass("mini-cart-menu") || $(e.target).parents(".mini-cart-menu").length){
          if(headerSearch.hasClass('header-search--open')) {
            headerSearch.removeClass('header-search--open');
          }
          if(userLink.hasClass('open')) {
            userLink.removeClass('open');
            navUser.hide();
          }
      }
    }
  });

  function phone_validate(phno){
    var regexPattern=new RegExp(/^[0-9]+$/);    // regular expression pattern
    return regexPattern.test(phno);
  }

  function getValidatePartnerQuota(cartItems, callback) {
    const customerInfoElm = $('#customer-infor');
  
    const customerInfo = {
      customerId: customerInfoElm.data('customer-id'),
      partnerCode: customerInfoElm.data('partner-code'),
      customerEmail: customerInfoElm.data('customer-email'),
    };
  
    if(!customerInfo.customerId) {
      callback();
      return;
    };
  
    const dataItems = cartItems.map(item => ({
      variantid: item.variant_id,
      productid: item.product_id,
      quantity: item.quantity
    }));
  
    const storeId = window.partner.storeId.toString();
    const dataString = JSON.stringify({
      storeid: storeId,
      customeremail: customerInfo.customerEmail,
      partnerCode: customerInfo.partnerCode,
      cartitemids: dataItems
    });
  
    $.ajax({
      method: 'POST',
      async: false,
      url: `${window.partner.omsValidateOrderQuotation}`,
      headers: {
        'Ocp-Apim-Subscription-Key': window.partner.omsApimSubscriptionKey,
        'issuer': storeId,
        'Accept-Language': 'en-US'
      },
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        'jsonstr': dataString
      })
  
    }).done(result => {
      if (result) {
        const valueReult = JSON.parse(result.value);
        callback(valueReult[0]);
      }
    })
    .fail(err => {
      console.log('err: ', err);
    });
  };

  function ValidatePartnerQuota(hrefUrl, id, increase_quantity, currentQty, self) {
    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart) {
      const newCartItems = cart.items?.filter(ele => ele.properties['_new_line_price'] && ele.properties['_new_line_price'] != 'NaN');

      const increaseItem = newCartItems.find((item) => {
        return item.id == id
      });

      if (increaseItem) {
        increaseItem.quantity = parseInt(increase_quantity);
      }

      console.log(newCartItems);

        getValidatePartnerQuota(newCartItems, function(result) {
          if(result && result.validTotalQuota.toLowerCase() === "false") {
            if(currentQty) {
              self.val(currentQty);
            }

            self.parent().find('.error_Msg').css("display", "block");
            self.addClass("has-error");
  
            alert('The total/yearly quota has exceeded.');
            
            return;
          }
  
          if (result) {
            let strError = '';
            const arrayInValidVariantIds = JSON.parse(result.inValidVariantIds.replace(',]', ']'));
  
            if (arrayInValidVariantIds && arrayInValidVariantIds.length > 0) {
              arrayInValidVariantIds.forEach(element => {
                const dataItem = newCartItems.find(item => item.variant_id == element);
  
                if (dataItem) {
                  strError += 'The product "' + dataItem.title + '" has exceeded category quota.\n';
                }
              });
  
              if (strError.length > 0) {
                if(currentQty) {
                  self.val(currentQty);
                }

                self.parent().find('.error_Msg').css("display", "block");
                self.addClass("has-error");
  
                alert(strError);
                return;
              }
            }
            
            window.location.href = hrefUrl;

          }
        });

    });
  }

  //update quantity in cart page
  $(".quantity-selector .decrease-quantity").click( function(event){
    event.preventDefault();

    $(this).parent().find('.error_Msg').hide();

    var link = $(this).attr("data-link"),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).data('quantity');

    var current_quantity = $(this).parent().find('input[name="update_quantity"]').val();

    quantity = parseInt(quantity);

    if (current_quantity != "" && phone_validate(current_quantity)) {
      if (current_quantity > 0) {
        var decrease_quantity = parseInt(current_quantity) - 1;

        // ValidatePartnerQuota(url, id, decrease_quantity);
        window.location.href = link + "&quantity=" + decrease_quantity + "&properties[_new_line_price]=" + decrease_quantity * newPrice;
      } 
      else {
        $(this).parent().find('.error_Msg').css("display", "block");
        $(this).addClass("has-error");
      }
    } 
    else {
      $(this).parent().find('.error_Msg').css("display", "block");
      $(this).addClass("has-error");
    }
  });

  $(".quantity-selector .increase-quantity").click( function(event){
    event.preventDefault();

    $(this).parent().find('.error_Msg').hide();

    var inventory_quantity = $(this).data('inventory-quantity'),
        link = $(this).attr("data-link"),
        id = $(this).attr("data-id"),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).data('quantity');

    var current_quantity = $(this).parent().find('input[name="update_quantity"]').val();

    quantity = parseInt(quantity);
    inventory_quantity = parseInt(inventory_quantity);

    if (current_quantity != "" && phone_validate(current_quantity)) {
      if (current_quantity >= inventory_quantity) {
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').text(window.languages.sold_out_message);
        $(this).parents(".cart-item__quantity").find('.error_Msg.not_update').css("display", "block"); // shows validation msg if validation is false
        $(this).addClass("has-error");
      } 
      else if (current_quantity > 0) {
        var increase_quantity = parseInt(current_quantity) + 1;

        // window.location.href = link + "&quantity=" + increase_quantity + "&properties[_new_line_price]=" + increase_quantity * newPrice;
        const url = link + "&quantity=" + increase_quantity + "&properties[_new_line_price]=" + increase_quantity * newPrice;

        ValidatePartnerQuota(url, id, increase_quantity, undefined , $(this));
      } 
      else {
        $(this).parent().find('.error_Msg').css("display", "block");
        $(this).addClass("has-error");
      }
    } 
    else {
      $(this).parent().find('.error_Msg').css("display", "block");
      $(this).addClass("has-error");
    }
  });
  
  $(".quantity-selector__current-quantity").on('change', function(event){
    event.preventDefault();

    var link = $(this).attr("data-link"),
        id = $(this).data('id'),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).val();

    var currentQty = $(this).data('value');

    if (phone_validate(quantity) && quantity > 0) {
      $(this).parent().find('.error_Msg').hide(); // hides error msg if validation is true
      $(this).removeClass("has-error");

      if (phone_validate(quantity)) {
        const url = link + "&quantity=" + quantity + "&properties[_new_line_price]=" + quantity * newPrice;

        ValidatePartnerQuota(url, id, quantity, currentQty, $(this));
        // window.location.href = link + "&quantity=" + quantity + "&properties[_new_line_price]=" + quantity * newPrice;
      }
    } 
    else {
      $(this).parent().find('.error_Msg').css("display", "block"); // shows validation msg if validation is false
      $(this).addClass("has-error");
    }
  });

  $(".quantity-selector__current-quantity").on('keyup', function(event){
    event.preventDefault();

    var link = $(this).attr("data-link"),
        id = $(this).data('id'),
        newPrice = $(this).closest('.cart-item').data('new-price'),
        quantity = $(this).val();

    var currentQty = $(this).data('value');

    if (currentQty !== parseInt(quantity) && (event.key === 'Enter' || event.keyCode === 13)) {
      if (phone_validate(quantity) && quantity > 0) {
        $(this).parent().find('.error_Msg').hide(); // hides error msg if validation is true
        $(this).removeClass("has-error");
  
        if (phone_validate(quantity)) {
          const url = link + "&quantity=" + quantity + "&properties[_new_line_price]=" + quantity * newPrice;
  
          ValidatePartnerQuota(url, id, quantity, currentQty, $(this));
          // window.location.href = link + "&quantity=" + quantity + "&properties[_new_line_price]=" + quantity * newPrice;
        }
      } 
      else {
        $(this).parent().find('.error_Msg').css("display", "block"); // shows validation msg if validation is false
        $(this).addClass("has-error");
      }     
    }
  });
  
  // AA tracking
  $(".cart__items a.link").click(function (e) {
    const dataType = $(this).data('type');
    let carData = [];
    
    $.ajax({
      method: 'GET',
      async: false,
      url: '/cart.js',
      dataType: 'json'
    }).done(function (cart) {
      if (cart) {
        carData = cart.items;
      }
    });

    let variantValue;
    let type;
    switch(dataType) {
      case 'reduce':
        variantValue = $($(this).parents().eq(2)).data("variant-id");
        type = 'unitChangeMinus';
        break;
      case 'increase':
        variantValue = $($(this).parents().eq(2)).data("variant-id");
        type = 'unitChangePlus';
        break;
      case 'wishlist':
        variantValue = $($(this).parents().eq(1)).data("variant-id");
        if ($(this).hasClass( "wishlist_collections") && $(this).hasClass( "btn-active")) {
          type = 'favoriteRemove';
        } else {
          type = 'favoriteAdd';
        }
        break;
      case 'delete':
          variantValue = $($(this).parents().eq(1)).data("variant-id");
          type = 'unitDelete';
        break;
    }
    
    const data = carData?.find(ele => ele.variant_id == variantValue);
    console.log('data', data);
    if (data) {
      const dataDetail = {
        type: type,
        sku: data.sku,
        model: $(`input[name="model_${data.variant_id}"]`).val(),
        superModel: $(`input[name="superModel_${data.variant_id}"]`).val(),
        category: $(`input[name="sixdcode_${data.variant_id}"]`).val()
        // category: data.product_type.toString()
      };
      
      var event = new CustomEvent("cartEvent", {
        detail: dataDetail
      });
      document.dispatchEvent(event);
    }
  });
  
  $(".header__logo-link, .header__main-nav a.link, .nav-dropdown__item a.nav-dropdown__link").click(function () {
    let detail = {};
    if ($(this).hasClass("header__logo-link")) {
      detail = {
        type: 'headerHome',
        label: ''
      };
    } else {
      const name = $(this).attr("data-title");
      detail = {
        type: 'headerCategory',
        label: name
      };
    }
    dispatchEvent(detail);
  });
  
  $(`.header__link.search-form a.link, .header__link.wishlist a.link, .header__link.mini-cart-menu a.link, 
  .header__link.user__link a.nav-dropdown__link.link`).click(function () {
    let detail;
    if ($(this).attr('aria-label') === 'Search') {
      detail = {
        type: 'headerSearch',
        label: ''
      };
    } else if ($(this).attr('href') === '/pages/wishlist') {
      detail = {
        type: 'headerWishlist',
        label: ''
      };
    } else if ($(this).attr('aria-label') === 'Cart') {
      detail = {
        type: 'headerCart',
        label: ''
      };
    } else if ($(this).attr('alt') === 'Sign In') {
      detail = {
        type: 'headerSignIn',
        label: ''
      };
    } else if ($(this).attr('alt') === 'Register') {
      detail = {
        type: 'headerRegister',
        label: ''
      };
    }

    if (detail) {
      dispatchEvent(detail);
    }
  });
  
  $(`.fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev[alt="Prev"], 
  .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next[alt="Next"]`).click(function () {
    let detail;
    const type = $(this).attr("alt");
    if (type === "Next") {
      detail = {
        type: 'sliderArrow',
        label: 'Next'
      };
    } else {
      detail = {
        type: 'sliderArrow',
        label: 'Previous'
      };
    }
    dispatchEvent(detail);
  });
  
  $('.product-item__see-more.button-wrapper, .product-item__title a[class="link"]').click(function () {
    let modelName;
    if ($(this).is('.product-item__see-more, .button-wrapper')) {
      modelName = $(this).parent().find('.product-item__info .product-item__title a[class="link"]').html();
    } else {
      modelName = $(this).html();
    }

    const detail = {
      type: 'viewDetail',
      label: modelName
    };
    dispatchEvent(detail);
  });
  
  $('.collection__filter.styled-select.collection-sort-by select').change(function () {
    const detail = {
      type: 'sortingClick',
      label: ''
    };
    dispatchEvent(detail);
  });
  
  $('.fs-slideshow__plyr-container').click(function() {
    const titleVideo = $(this).find('iframe').attr('title');
    const detail = {
      type: 'videoClick',
      label: titleVideo
    }
    dispatchEvent(detail);
  });
  
  $(`#shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-prev.slick-prev.slick-arrow, 
  #shopify-section-product-template .fs-slideshow__nav-button.fs-slideshow__nav-next.slick-next.slick-arrow`).click(function () {
    let sliderArrow;
    const type = $(this).attr("title");
    if (type == "Prev") {
      sliderArrow = "Previous";
    } else {
      sliderArrow = "Next";
    }

    const detail = {
      type: 'sliderArrow',
      label: sliderArrow
    }
    dispatchEvent(detail);
  });
  
  $('.styled-select.styled-select--secondary select.single-option-selector').change(function () {
    const sizeSelect = $(this).val();
    const detail = {
      type: 'screenSize',
      label: sizeSelect
    }
    dispatchEvent(detail);
  });
  
  $('.product__slide-wrapper').click(function() {
    const detail = {
      type: 'carouselClick',
      label: ''
    }
    dispatchEvent(detail);
  });
  
  $('.quantity-selector a[data-action="increase-product-quantity"], .quantity-selector a[data-action="decrease-product-quantity"]').click(function () {
    let unitChange;
    var parent = $(this).parents('.product__details');
    if ($(this).attr('data-action') == 'increase-product-quantity') {
      unitChange = 'Plus';
    } else {
      unitChange = 'Minus';
    }

    const detail = {
      type: 'unitChange',
      label: unitChange,
      model: parent.find(`input[name^="model_"]`).val(),
      superModel: parent.find(`input[name^="superModel_"]`).val(),
      category: parent.find(`input[name^="sixdcode_"]`).val(),
    }
    dispatchEvent(detail);
  });

  $('.form__control.variant-colour .product__available-colors input[type="radio"]').change(function () {
    const color = $(this).val();
    const detail = {
      type: 'colorSwatch',
      label: color
    }
    dispatchEvent(detail);
  });
  
  $('body[class^="product"] li.tabs__nav-item').click(function () {
    const tabName = $(this).html().trim();
    //there was another event for Reviews
    if (tabName !== 'Reviews') {
      const detail = {
        type: 'stickynav',
        label: tabName
      };
      dispatchEvent(detail);
    }
  });
  
  $('.checkout-btn .button--continue-shoping').click(function () {
    const detail = {
      type: 'continueShopping',
      label: 'continueShopping'
    }
    dispatchEvent(detail);
  });
  
  function dispatchEvent(dataDetail) {
    var event = new CustomEvent("linkInteraction", {	
      detail: dataDetail	
    });	

    document.dispatchEvent(event);	
  };
  // End AA Tracking   

  $(".cart__checkout-button").on("click", function(e){
    e.preventDefault();

    if($(".quantity-selector__current-quantity").hasClass("has-error")){
        return false;
    }

    $.ajax({
      method: 'GET',
      url: '/cart.js',
      dataType: 'json'
    }).then(function(cart) {
      const skuValue = cart.items.map(element => element.sku.toString());
      const modelValue = cart.items.map(element => $(`input[name="model_${element.variant_id}"]`).val());
      const superModelValue = cart.items.map(element => $(`input[name="superModel_${element.variant_id}"]`).val());
      const categoryValue = cart.items.map(element => $(`input[name="sixdcode_${element.variant_id}"]`).val());
      // const categoryValue = cart.items.map(element => element.product_type.toString());
      const quantityValue = cart.items.map(element => element.quantity.toString());
      const discountValue = cart.items.map(element => element.total_discount.toString());
      // const priceValue = cart.items.map(element => Shopify.formatMoney(element.price.toString()));
      // const discountpriceValue = cart.items.map(element => Shopify.formatMoney(element.discounted_price.toString()));
      const priceValue = cart.items.map(element => $(`input[name="retailPrice_${element.variant_id}"]`).val());
      const discountpriceValue = cart.items.map(element => $(`input[name="sellingPrice_${element.variant_id}"]`).val());

      const detailItems = {
        sku: skuValue,
        model: modelValue,
        superModel: superModelValue,
        quantity: quantityValue,
        price: priceValue,
        category: categoryValue,
        discount: discountValue,
        discountprice: discountpriceValue,
        loyaltyPoints: 0
      };

      var event = new CustomEvent("checkoutEvent", {
        detail: detailItems 
      });
      document.dispatchEvent(event);

      checkoutSubmit();
    });    
  });

  function checkoutSubmit() {
    if($('button.cart__checkout-button').length > 0) {
      window.location.href = "/checkout";
    } else if($('a.cart__checkout-button').length > 0) {
      var hrefLink = $('a.cart__checkout-button').attr('href');
      window.location.href = hrefLink;
    }
  };

  $(".main-menu__links > li").click(function(){
    setTimeout(function(){
      checkDevice();
    }, 500);
  });

  function initWishlist() {
    const customerInfoElm = $('#customer-infor');

    const customerInfo = {
      customerId: customerInfoElm.data('customer-id'),
      partnerCode: customerInfoElm.data('partner-code'),
      customerEmail: customerInfoElm.data('customer-email'),
    };

    if(customerInfo.customerId === '') {
      loginWishlist();
    }
    else {
      checkWishlistStatus(customerInfo);
      addWishlist(customerInfo);
      removeWishlist(customerInfo);
      getWishlist(customerInfo);
      initWishlistCollectionEvt();
    }
  }

  function loginWishlist(){
    $('.wishlist-modal').click(function(e){
      var container = $(".wishlist-modal .content");

      if (!container.is(e.target) && container.has(e.target).length === 0){
        $('.wishlist-modal').removeClass('wishlist-popup-wrapper');
      }
    });

    $(".wishlist_login").on("click", function(e){
      e.preventDefault();

      $(".wishlist-modal").toggleClass('wishlist-popup-wrapper');

      $(".wishlist-modal .close-popup").on("click", function(){
        $(".wishlist-modal").removeClass('wishlist-popup-wrapper');
      });
    });
  }

  function updateWishlistStatus(isActive, elms) {
    if(isActive) {
      elms.addClass('btn-active');
      elms.find('.tooltip').text(window.languages.removeWishlistText);
    }
    else {
      elms.removeClass('btn-active');
      elms.find('.tooltip').text(window.languages.addWishlistText);
    }
  }

  const apiRequest = new ApiFetch();

  function checkWishlistStatus(customerInfo) {
    const wishlistElm = $('.wishlist_collections');

    apiRequest.fetcher('wishlist')
      .then(function(res) {
        if(!res?.data.length) return;

        // Update wishlist detail page
        const productDetailWishlist = $('.product__details .wishlist_collections');

        if(productDetailWishlist.length) {
          productDetailWishlist.each((_, w) => {
            const productHandle = $(w).data('product-handle');

            const handles = res.data.filter((item) => {
              return item.handle == productHandle;
            });

            const listVariantId = handles.map((v) => {
              return v.variant_id;
            })

            $(w).siblings('.input_variants').attr('data_variants', listVariantId);
          })
        }

        wishlistElm.each((_, w) => {
          const variantId = $(w).data('variant-id');

          const isActive = res.data.some((item) => {
            return item.variant_id == variantId;
          });

          updateWishlistStatus(isActive, $(w));
        });

        $('.wishlist__count').text(res?.data.length);
      })
      .fail((err) => {
        console.log('error when call api get WishlistMetafields_Partner', err);
      });
  }

  function addWishlist(customerInfo){
    const addWishlistSlt = '.wishlist_collections';

    $(document).off('click.addWishlist', addWishlistSlt).on('click.addWishlist', addWishlistSlt, function(e) {
      e.preventDefault();

      const self = $(this);
      self.addClass('disabled');
      self.find('.tooltip').text(window.languages.added);

      if(!self.hasClass('btn-active')) {
        const productId = self.data('product-id'),
              ProductHandle = self.data('product-handle'),
              variantId = self.data('variant-id');

        apiRequest.post('wishlist', {
          "product_id": productId,
          "variant_id": variantId,
          "handle": ProductHandle
        })
        .then(function(res){
          if(res.status) {
            self.addClass('btn-active');
  
            let wishlistCount = $('.header__secondary-nav .wishlist__count').text();
            wishlistCount = parseInt(wishlistCount) + 1;
  
            $.cookie("els", wishlistCount);
            $('.wishlist__count').text(wishlistCount);
  
            updateWishlistStatus(true, $(`${addWishlistSlt}[data-variant-id=${variantId}]`));
          }

        })
        .fail((err) => {
          console.log('error when call api add WishlistMetafields_Partner', err);
        })
        .always(() => {
          self.removeClass('disabled');
        });        
      }
    })
  };

  function removeWishlist(customerInfo){
    const removeWishlistSlt = '.wishlist_collections.btn-active';

    $(document).off('click.removeWishlist', removeWishlistSlt).on('click.removeWishlist', removeWishlistSlt, function(e) {
      e.preventDefault();

      const self = $(this);
      self.addClass('disabled');
      self.find('.tooltip').text(window.languages.removed);

      const productHandle = self.data('product-handle'),
            variantId = self.data('variant-id');

      apiRequest.delete('wishlist', {
        'handle': productHandle,
        'variant_id': variantId
      }).then(function(res){
        if(res.status) {
          self.removeClass('btn-active');
  
          let wishlistCount = $('.header__secondary-nav .wishlist__count').text();
          wishlistCount = parseInt(wishlistCount) - 1;
  
          $.cookie("els", wishlistCount);
          $('.wishlist__count').text(wishlistCount);
  
          updateWishlistStatus(false, $(`.wishlist_collections[data-variant-id=${variantId}]`));
        }
      })
      .fail((err) => {
        console.log('error when call api remove WishlistMetafields_Partner', err);
      })
      .always(() => {
        self.removeClass('disabled');
      });

      if(self.closest('.wishlist-content').length) {
        self.closest('.grid__cell').remove();
      }
    });
  }

  function getPriceForWishlist(customerInfo, listProductId, handleRenderTpl) {
    const storeId = window.partner.storeId.toString();

    $.ajax({
      method: 'POST',
      url: `${window.partner.omsGetPriceByListProductIds}`,
      headers: {
        'Ocp-Apim-Subscription-Key': window.partner.omsApimSubscriptionKey,
        'issuer': storeId,
        'Accept-Language': 'en-US'
      },
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify({
        'storeid': storeId,
        'listproductid': JSON.stringify(listProductId),
        'partnercode': customerInfo.partnerCode,
        'customeremail': customerInfo.customerEmail.toLowerCase()
      })

    }).done(function(res){
      const resultValue = JSON.parse(res?.value);
      // Update price data result
      handleRenderTpl(resultValue);

    })
    .fail(function(err) {
      handleRenderTpl();
      console.log('error when call api get price for wishlist page');
    });
  }

  function updateWishlistItemPrice(price, comparePrice, partnerPrice, wishlistItemElm) {
    const newPrice = comparePrice ? Math.min(price, comparePrice, partnerPrice) : Math.min(price, partnerPrice);
    const oldPrice = comparePrice ? Math.max(price, comparePrice, partnerPrice) : Math.max(price, partnerPrice);
    const discountPercent = (oldPrice - newPrice) / oldPrice * 100;
    const newPriceFormatted = Shopify.formatMoney(newPrice, window.theme.moneyFormat);
    const oldPriceFormatted = Shopify.formatMoney(oldPrice, window.theme.moneyFormat);

    if(partnerPrice) {
      wishlistItemElm.find('.product-content-bottom').data('new-price', newPrice);
    }

    if((comparePrice && (price === newPrice) && (comparePrice === oldPrice)) || !comparePrice && (price === newPrice)) return;

    // update price ==> format money
    if (comparePrice && oldPrice > newPrice) {
      wishlistItemElm.find(".product-item__image-container .discount").show();
      wishlistItemElm.find(".product-item__image-container .discount .price-save").html(discountPercent.toFixed(0)+"%");

      wishlistItemElm.find('.product-item__price').remove();
      
      if (!wishlistItemElm.find('.product-item__price--old').length) {
        wishlistItemElm.find('.product-content-bottom').prepend(`
          <span class="product-item__price product-item__price--old" data-money-convertible>
          ${oldPriceFormatted}
          </span>
        `)
      } else {
        wishlistItemElm.find('.product-item__price--old').html(oldPriceFormatted);
      }

      if (!wishlistItemElm.find('.product-item__price--new').length) {
        wishlistItemElm.find('.product-content-bottom').prepend(`
          <span class="product-item__price product-item__price--new" data-money-convertible>
          ${newPriceFormatted}
          </span>
        `)
      } else {
        wishlistItemElm.find('.product-item__price--new').html(newPriceFormatted);
      }
    } 
    else {
      wishlistItemElm.find(".product-item__image-container .discount").hide();
      wishlistItemElm.find('.product-item__price').html(Shopify.formatMoney(newPrice, window.theme.moneyFormat));
    };
  }

  function getWishlist(customerInfo){
    const wishlistContent = $('.wishlist-page .wishlist-content');

    if(!wishlistContent.length) return;

    apiRequest.fetcher('wishlist').then(function(res) {
        if(!res?.data.length) return;

        const data = res.data;

        const handleArr = data.map((item) => {
          return item.handle;
        });

        const productIds = data.map((item) => {
          return parseInt(item.product_id);
        })

        // Call api getPrice
          getPriceForWishlist(customerInfo, [...new Set(productIds)], function(priceData) {
            [...new Set(handleArr)].forEach((handle) => {           
              $.get('/products/'+ handle +'?view=wishlist', function(tpl) {
                const wishlistItem = $(tpl);
  
                wishlistContent.append(wishlistItem);
  
                const wishlistItems = wishlistContent.find('.grid__cell');
  
                wishlistItems.each((_, w) => {
                  const variantId = $(w).data('variant');
  
                  const hasWishlist = data.find((i) => {
                    return i.variant_id == variantId;
                  });
  
                  if(!hasWishlist) {
                    $(w).remove();
                  }
                  else {      
                    $(w).show();
  
                    if(priceData) {
                      // Update Price for wishlist item
                      const productItemId = $(w).find('.product-item').data('product-id').toString();
                      const productItemData = priceData.find(item => item.productid === productItemId);
    
                      if (!productItemData) return;
    
                      const variantId = $(w).find('.product-content-bottom').data('variant-id').toString();
                      const variantData = productItemData.variant.find(v => v.id === variantId);
    
                      if (!variantData) return;
    
                      const partnerOrginalPrice = variantData.price;
    
                      if(!partnerOrginalPrice) return;
    
                      const price = $(w).find('.product-content-bottom').data('price');
                      const comparePrice = $(w).find('.product-content-bottom').data('compare-price');
    
                      updateWishlistItemPrice(price, comparePrice, partnerOrginalPrice * 100, $(w));
                    }
                  }
  
                })
              })
            })
          });
      })
      .fail((err) => {
        console.log('error when call api get WishlistMetafields_Partner');
      });     
  }

  function initWishlistCollectionEvt() {
    if ($('.product__details').length > 0) {
      $(".product__details .wishlist_collections").click(function(){
        var s = $(this).data('variant-id');
        var d = $(".product__details .input_variants").attr("data_variants");
        var wishlistarrays = d.split(",");

        if ($.inArray($(this).attr("data-variant-id"), wishlistarrays) !== -1) {
          d = d.replace(s+",", "").replace(","+s, "").replace(s, "");
          $(".product__details .input_variants").attr("data_variants", d);
        }
        else {
          if(d != ""){
            $(".product__details .input_variants").attr("data_variants", d + "," + s);
          }
          else {
            $(".product__details .input_variants").attr("data_variants", s);
          }
        }
      });

      // var selected = $("#sony-new-variant" ).val();
      $(document).on('variant_changed.product', function(evt, variant) {
        const variantId = variant.id;
        
        $(".product__details .wishlist_collections").attr('data-variant-id', variantId);
      });

    }
  }

  function checkoutlink(){
    $(document).on('click', '.checkout_link', function(e){
      $.cookie('check_out', "checkout",{expires:1, path:'/'});
    });

    if( $.cookie('check_out') != undefined && $('.check__out').length){
      $('body.template-customers-account').hide();
      window.location.href= "/cart";
      $.cookie('check_out', "checkout",{expires:-1, path:'/'});
    } 
    else{
      $('body.template-customers-account').show();
    }
  }

  if ($("body").hasClass("trademark--v3")) {
    checkoutlink();

    //custom product detail
    $( ".product-features .block-3column" ).each(function() {
      var block_3column_wrapper = $(this).html();
      $(this).html("<div>" + block_3column_wrapper + "</div>");
    });
  }

  /**order detail**/
  if ($("body").hasClass("template-customers-order")) {
    var shipping_label = $(".order__items .shipping-method").attr("data-label");

    if(shipping_label != "" && shipping_label.search ("Standard shipping") != -1){
      var shipping_label_new = shipping_label.replace("Standard shipping", window.languages.standard_shipping);
      $(".order__items .shipping-method").attr("data-label",shipping_label_new);
    }
  }

  /**Validate form edit**/
  if ($("body").hasClass("trademark--v3")) {
    $(".find_store__form [type='submit']").click(function () {
      $('.find_store__form').validate({
        rules: {
          '#find-store-postcode': {
            required: true
          }
        },

        submitHandler: function(form) {
          var postcode = $('#find-store-postcode').val();
          var url = $(".find_store__form").attr("action");
          url = url + "/?query=" + postcode;
          window.open(url, '_blank');
          return false;
        }
      });
    });

    $("#money_vat").text(Shopify.formatMoney($("#money_vat").text(), window.theme.order_money));
    $("#excluded_tax").text(Shopify.formatMoney($("#excluded_tax").text(), window.theme.order_money));
  }

  /***Delete Address***/
  $(".delete-address").click(function(event){
    if (confirm(window.languages.delete_confirm)) {
      // your deletion code
      var address_id = $(this).attr("data-address-id");

      Shopify.postLink('/account/addresses/'+ address_id, {'parameters': {'_method': 'delete'}});
    }
    else{
      event.preventDefault();
    }

    return false;
  });

  /**Show review tab after clicking star**/
  window.bvCallback = function(BV) {
    if (!BV) return;

    BV.reviews.on('show', function() {
      if($(window).innerWidth() > 800){
        $('.gwt__tab--active .tabs__nav-item.review-tab-title').click();

        setTimeout(function(){
          $('html, body').animate({
            scrollTop: $(".gwt__tab--active.product__tabs").offset().top - 100
          }, 0);
        }, 100);
      }
      else {
        if(!$(".gwt__tab-m--active .tabs__nav-item-m > .review-tab-title").hasClass("active")){
          $('.gwt__tab-m--active .tabs-title.review-tab-title').click();
        }

        setTimeout(function(){
          $('html, body').animate({
            scrollTop: $(".gwt__tab-m--active .tabs-title.review-tab-title").offset().top - 100
          }, 0);
        }, 100);
      }

      return false;

    });
  };

  function moveReviewToTabs(){
    var reviewHtml = '';

    if($(".product-review-container").length && reviewHtml == ""){
      reviewHtml = $(".product-review-container").html();
      $(".product-review-container").remove();
    }
    else if($(window).innerWidth() > 800 && reviewHtml == "") {
      reviewHtml = $(".tabs__content-item.review-tab .product-review #BVRRSearchContainer").parents(".product-review").html();
    }
    else if($(window).innerWidth() <= 800 && reviewHtml == "") {
      reviewHtml = $(".tabs__content-item-m .review-tab-m .product-review-m #BVRRSearchContainer").parents(".product-review-m").html();
    }

    if($(window).innerWidth() > 800){
      $(".product-review-m").html("");

      $(".product__tabs").each(function(){
        if($(this).hasClass("gwt__tab--active")){
          //move review
          $(this).find(".tabs__content-item.review-tab .product-review").html(reviewHtml);
        }
        else {
          $(this).find(".tabs__content-item.review-tab .product-review").html("");
        }
      });
    }
    else {
      $(".product-review").html("");
      $(".product__tabs-m").each(function(){

        if($(this).hasClass("gwt__tab-m--active")){
          //move review
          $(this).find(".tabs__content-item-m .review-tab-m .product-review-m").html(reviewHtml);
        }
        else {
          $(this).find(".tabs__content-item-m .review-tab-m .product-review-m").html("");
        }
      });
    }
  }

  var variantSelector = $(".product__form .single-option-selector");

  variantSelector.on("change", function() {
    $(".tabs__nav-item").removeClass("tabs__nav-item--active");
    $(".tabs__content-item").removeClass("tabs__content-item--active");
    $(".tabs-title.review-tab-title").removeClass("active");
    $(".tabs__nav-item-m .tabs-title + ul").hide();

    setTimeout(function(){
      $(".product__tabs.gwt__tab--active").find(".tabs__nav-item:first-child").addClass("tabs__nav-item--active");
      $(".product__tabs.gwt__tab--active").find(".tabs__content-item:first-child").addClass("tabs__content-item--active");
      $(".product__tabs-m.gwt__tab-m--active").find(".tabs__nav-item-m:first-child .tabs-title").addClass("active");
      $(".product__tabs-m.gwt__tab-m--active").find(".tabs__nav-item-m:first-child .tabs-title + ul").show();

      moveReviewToTabs();
    }, 800);
  });

  /**
   * js cateogry mobile
   */
  $(document).ready(function () {
    setWidthCategoryMobile();

    

    initWishlist();
  });

  var setWidthCategoryMobile = function () {
    var widthBrowser = $(window).width();

    if (widthBrowser < 768) {
      var categoryItem = $(".js-list-category-mobile .category-item");
      var withcategoryItem = categoryItem.width(widthBrowser * 0.21);

      $(".js-list-category-mobile").width(categoryItem.length * withcategoryItem);
    } 
    else {
      $(".js-list-category-mobile").width('auto');
    }
  }

  function getSocialAccounts(){
    let customer_id = $('.header__secondary-nav .wishlist a').attr('data-customer_id');

    callAPIWithTokenRefresh(`customers/get_social_by_ShopifyCustomer?customerID=${customer_id}`, 'get')
      .then(function(res) {
        if (res.length > 0) {
          res.forEach((element, index) => {
            appendDataSocialList(element, index);
            // console.log(element.socialId);

            let buttonUnlink = $(`.social-account-listing__item .button[data-index="button-index-${index}"]`);
            let idpLogin = $('#idp-login').val();
            let messageConfirmDelete;
            if (idpLogin == 'google.com') {
              messageConfirmDelete = `${$('#message-unlink').val()} GOOGLE`;
            } else if (idpLogin == 'facebook.com') {
              messageConfirmDelete = `${$('#message-unlink').val()} FACEBOOK`;
            } else if (idpLogin == 'https://access.line.me') {
              messageConfirmDelete = `${$('#message-unlink').val()} LINE`;
            }

            // let messageUnlinkSuccess = $('#message-unlink-success').val();
            buttonUnlink.on('click', function() {
              if (confirm(messageConfirmDelete)) {
                window.location.href= "https://login.sony-asia.com/10a6c4a3-6d70-4565-9c95-e3b2581b4018/oauth2/v2.0/authorize?p=B2C_1_eComMY_PRD_su_si&client_id=884e8848-e166-4ed3-8796-2b731b0829c2&nonce=defaultNonce&redirect_uri=https://hub.sony-asia.com/api/stores/25634013218/customers/socialunlink&scope=openid&response_type=code&response_mode=query";
                
                $('.social-account-loading').removeClass('hide');
              }
            })
          });
        } 
        else {
          let messageAccountEmpty = $('#message-account-empty').val();

          $('.social-account-listing').append(`
            <li class="social-account-listing__item social-account-listing__item--sms">
              <p class="sms-empty">${messageAccountEmpty}</p>
            </li>`
          );
        }
      })
  };

  function appendDataSocialList(social, index) {
    let socialAccountListing = $('.social-account-listing');
    let idpLogin = $('#idp-login').val();

    let itemGoogle = `
      <li class="social-account-listing__item social-account-listing__item--gg">
        <span class="account-button account-button--gg">Google</span>
        ${
          idpLogin == 'google.com' ? `<button class="button button--blue" data-index="button-index-${index}">Unlink</button>` : `<button class="button button--blue disabled" data-index="button-index-${index}">Unlink</button>`
        }
      </li>
    `;

    let itemFacebook = `
      <li class="social-account-listing__item social-account-listing__item--fb">
        <span class="account-button account-button--fb">Facebook</span>
        ${
          idpLogin == 'facebook.com' ? `<button class="button button--blue" data-index="button-index-${index}">Unlink</button>` : `<button class="button button--blue disabled" data-index="button-index-${index}">Unlink</button>`
        }
      </li>
    `;

    let itemLine = `
      <li class="social-account-listing__item  social-account-listing__item--line">
        <span class="account-button account-button--line">Line</span>
        ${
          idpLogin == 'https://access.line.me' ? `<button class="button button--blue" data-index="button-index-${index}">Unlink</button>` : `<button class="button button--blue disabled" data-index="button-index-${index}">Unlink</button>`
        }
      </li>
    `;

    if (social.socialPlatform == 0) {
      socialAccountListing.append(itemGoogle);
    } else if (social.socialPlatform == 1) {
      socialAccountListing.append(itemFacebook);
    } else if (social.socialPlatform == 2) {
      socialAccountListing.append(itemLine);
    }
  }

  function checkStatusUnlink(){
    let messageUnlinkError = $('#message-unlink-error').val();
    let pageUrl = window.location.search.substring(1);
    let urlVariable = pageUrl.split('&');
    let urlInfo = {};
    let idpLogin = $('#idp-login').val();
    let messageUnlinkSuccess;

    if (idpLogin == 'google.com') {
      messageUnlinkSuccess = `${$('#message-unlink-success').val()} GOOGLE`;
    } else if (idpLogin == 'facebook.com') {
      messageUnlinkSuccess = `${$('#message-unlink-success').val()} FACEBOOK`;
    } else if (idpLogin == 'https://access.line.me') {
      messageUnlinkSuccess = `${$('#message-unlink-success').val()} LINE`;
    }

    for (let entry of urlVariable) {
      let pair = entry.split("=");
      urlInfo[pair[0]] = pair[1];
    }

    if (pageUrl) {
      if (urlInfo.UnlinkResult == 'True') {
        $('.social-account-listing').append(`
          <li class="social-account-listing__item social-account-listing__item--sms">
            <p class="sms-success">${messageUnlinkSuccess}</p>
          </li>`
        );
      } else if (urlInfo.UnlinkResult == 'False') {
        $('.social-account-listing').append(`
          <li class="social-account-listing__item social-account-listing__item--sms">
            <p class="sms-error">${messageUnlinkError}</p>
          </li>`
        );
      }
      $('.social-account-loading').addClass('hide');
      window.history.pushState("", "", window.location.pathname);
    }
  };
  // End Social Account Page
}(jQuery));


